/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { View } from "react-native";
import Rodal from "rodal";
import { useSelector, useDispatch } from "react-redux";
import { skalePrimaryBlue, skaleWhite } from "config/UpduoColors";
import { RootState } from "store/types";

import { Button, Text } from "UpduoLibrary";
import { ActionCreators } from "actions";
import { useHistory } from "react-router-dom";
import * as UpduoAnalytics from "config/UpduoAnalytics";

interface ProprietaryPopupModalProps {
  bodyText?: string;
  origin: string;
}

export default function ProprietaryPopupModal({
  bodyText = "The video you are about to watch is considered proprietary information.\n Please confirm your understanding.",
  origin,
}: ProprietaryPopupModalProps) {
  const dispatch = useDispatch();
  const history = useHistory();

  const proprietaryPopupModalIsVisible = useSelector(
    (state: RootState) => state.proprietaryPopupModalIsVisible
  );

  const _handleIUnderstandButton = () => {
    UpduoAnalytics.logEvent("user-ack-proprietary-popup");
    dispatch(ActionCreators.setProprietaryPopupModalIsVisible(false));
  };

  const _handleRejectButton = () => {
    UpduoAnalytics.logEvent("user-reject-proprietary-popup");
    dispatch(ActionCreators.setVideoInfo(null));
    dispatch(ActionCreators.setProprietaryPopupModalIsVisible(false));
    switch (origin) {
      case "video_route": {
        history.go(0);
        break;
      }
      default: {
        break;
      }
    }
  };

  return (
    <Rodal
      visible={proprietaryPopupModalIsVisible}
      onClose={_handleRejectButton}
      customStyles={{ borderRadius: 10 }}
      customMaskStyles={{ height: "155%", borderRadius: 10 }}
    >
      <View
        style={{
          alignItems: "center",
          justifyContent: "space-around",
          padding: 20,
          height: "100%",
        }}
      >
        <Text isHeading={true} style={{ fontSize: 18 }}>
          {`Reminder!`}
        </Text>

        <Text style={{ textAlign: "center" }}>{bodyText}</Text>

        <Button
          onPress={_handleIUnderstandButton}
          text={"I Understand"}
          marginTop={20}
        />
        <Button
          onPress={_handleRejectButton}
          text={
            origin === "video_route"
              ? "Return to Home"
              : origin === "summit_admin"
              ? "Return to Events"
              : "Return to Dashboard"
          }
          borderColor={skalePrimaryBlue}
          color={skaleWhite}
          textColor={skalePrimaryBlue}
          marginTop={20}
        />
      </View>
    </Rodal>
  );
}
